import { useId } from 'react';
import clsx from 'clsx';
import { Layers } from '@/components/icons';
import { collectionGroups, type RunCollectionState } from '@/lib/runCollection';
import { Select } from '@/components/ui';

/** The test data used in every environment (values outside any collection). */
export const SHARED_VALUES_LABEL = 'Shared values';
/** Run / schedule choice without a collection. */
export const NO_COLLECTION_LABEL = 'No collection (shared values only)';

/**
 * "Test data: Staging" choice shown next to Run buttons. Hidden until the project can use at least
 * one collection, so projects without environments look as before.
 */
export function RunCollectionPicker({ state, className }: { state: RunCollectionState; className?: string }) {
  const id = useId();
  if (state.collections.length === 0) return null;
  return (
    <div className={clsx('inline-flex items-center gap-2 text-sm', className)} title="Which test data collection (environment) runs use">
      <label htmlFor={id} className="inline-flex items-center gap-1.5 text-xs font-medium tracking-label whitespace-nowrap text-fg-secondary uppercase">
        <Layers className="size-3 text-primary" aria-hidden /> Test data
      </label>
      <Select
        id={id}
        value={state.collectionId ?? ''}
        onChange={(e) => state.setCollectionId(e.target.value || null)}
        options={[{ value: '', label: NO_COLLECTION_LABEL }]}
        groups={collectionGroups(state.collections)}
        className="w-44 max-w-full"
      />
    </div>
  );
}
